import Link from "next/link";

import { ChevronDownIcon } from "@/components/icons/chevronDown.icon";

import {
  hasNavigationLink,
  type NavigationMenuGroupItem,
} from "./navigationQuery.types";

export const HeaderMobileSubMenu = ({ menu }: HeaderMobileSubMenuProps) => {
  const renderNav = () => {
    if (!menu.items?.length) return null;
    return menu.items.map((nav) => {
      if (!hasNavigationLink(nav) || !nav.link.url) return null;
      const target = nav.link.openInNewTab ? "_blank" : "_self";

      return (
        <li
          data-testid="header-mobile-sub-menu-list-item"
          key={nav.label}
          className="hover:bg-secondary-100 flex duration-500">
          <Link
            className="w-full p-4 whitespace-nowrap"
            href={{
              pathname: nav.link.url,
              query: nav.link.queryString,
            }}
            target={target}>
            {nav.label}
          </Link>
        </li>
      );
    });
  };
  return (
    <details
      key={menu.label}
      name="mobile-menu-details"
      data-testid="header-mobile-sub-menu"
      className="group flex w-full flex-col">
      <summary
        data-testid="header-mobile-sub-menu-summary"
        className="hover:bg-secondary-100 flex cursor-pointer list-none justify-between p-4 whitespace-nowrap duration-500 [&::-webkit-details-marker]:hidden">
        {menu.label}
        <ChevronDownIcon
          data-testid="header-mobile-sub-menu-chevron"
          className="group-open:rotate-180"
          aria-hidden
        />
      </summary>
      <div className="pl-4">
        <nav
          data-testid="header-mobile-sub-menu-nav"
          className="border-secondary-100 mt-6"
          aria-label={`${menu.label} sub menu`}
          style={{
            borderLeft: "2px solid transparent",
            borderImage:
              "linear-gradient(to bottom, var(--color-primary-200), var(--color-secondary))",
            borderImageSlice: 1,
          }}>
          <ul
            data-testid="header-mobile-sub-menu-list"
            className="flex flex-col gap-1">
            {renderNav()}
          </ul>
        </nav>
      </div>
    </details>
  );
};

export type HeaderMobileSubMenuProps = {
  menu: NavigationMenuGroupItem;
};
